export default __webpack_public_path__ + "static/media/Limit.23b8088d.svg";